jQuery(function() {
  var sliderSelector = ".swiper._voice"; // スライダーのコンテナーとなる要素のセレクタ
  if (window.matchMedia("(min-width: 769px)").matches) {
    /* ウィンドウサイズが 768px以上の場合に有効にしたい処理*/
    var slidesPerView = 3; // スライド表示数
  } else {
    var slidesPerView = 1; // スライド表示数
  }

  console.log(slidesPerView);

  var $slide = jQuery(sliderSelector + " .swiper-slide");
  var slidable = $slide.length > slidesPerView;

  var containerModifierClass = slidable ? "is-active swiper-container-" : "swiper-container-"; // スライドがアクティブな場合は、コンテナー要素にクラス名「is-active」を設定
  const mySwiper1 = new Swiper(".swiper._voice", {
    containerModifierClass: containerModifierClass,
    slidesPerView: 1,
    lpp: true,
    spaceBetween: 30, // スライド間の余白（px）
    preloadImages: false,
    lazy: {
      loadPrevNext: true
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    speed: 1500,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    watchOverflow: true,
    breakpoints: {
      // 横幅768px以上のとき～
      768: {
        slidesPerView: 3,
        loop: slidable
      }
    }
  });
  mySwiper1.autoplay.stop(); //画面に現れるまでswiperを停止
  window.addEventListener("scroll", function() {
    // スライダーのコンテナ要素を取得
    const sliderContainer = document.querySelector(".swiper");
    // スライダーのコンテナの位置情報を取得
    const rect = sliderContainer.getBoundingClientRect();
    // ウィンドウの高さを取得（クロスブラウザ対応）
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top < windowHeight && rect.bottom >= 0) {
      // スライダーが画面内に入った場合、自動再生を有効にして開始
      mySwiper1.autoplay.start();
    } else {
      // 画面外に出た場合、自動再生を停止
      mySwiper1.autoplay.stop();
    }
  });
});
